<template>
    <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
    <div class="surface-50 h-screen">
        <div class="h-full">
            <Header>
                <template #menu>
                    <MenuHeader />
                </template>
            </Header>

            
            <div class="pt-8 sm:pt-5" v-if="verificandoAssinatura == false && assinaturaAtiva == false">
               <AppAssinar/>
            </div>


            <div class="p-3 md:p-6" v-if="verificandoAssinatura == false && assinaturaAtiva == true">
                <div class="flex justify-content-end pt-8 sm:pt-5 pb-5">
                    <Dropdown v-model="disciplinaSelecionada" :options="opcoesDisciplinas"
                        placeholder="Selecione uma disciplina" class="w-full md:w-14rem mr-2" optionValue="id"
                        optionLabel="disciplina" />
                    <Dropdown @change="listarTurmas" v-model="anoSelecionado" :options="anosLetivos"
                        placeholder="Selecione um ano letivo" class="w-full md:w-14rem" />
                </div>

                <div class="grid">
                    <div class="col-12 md:col-6 lg:col-3" v-for="turma in turmasFiltradas" :key="turma.idTurma">
                        <Card @click="verTurma({
                        idDaAula: turma.idDaAula,
                        idDaTurma: turma.idDaTurma,
                        nomeDaTurma: turma.nomeDaTurma,
                        anoDoEnsinoMedio: turma.anoDoEnsinoMedio,
                    })" class="card h-full shadow-1 hover:shadow-3 animation-duration-1000		">
                            <template #header>
                                <img class="img" alt="user header" :src="definirImagem(turma.anoDoEnsinoMedio)" />
                            </template>
                            <template #title> {{ turma.nomeDaTurma }}</template>
                            <template #subtitle>
                                <div class="flex justify-content-between">
                                    <div>{{ turma.anoDoEnsinoMedio }}° ano</div>
                                    <div>{{ turma.disciplina }}</div>
                                </div>
                            </template>
                        </Card>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script setup>
import { supabase } from '@/supabase';
import { useStore } from 'vuex'
import router from '@/router';
import Header from '@/components/layout/Header.vue';
import Dropdown from 'primevue/dropdown';
import { ref, onMounted, computed } from 'vue';
import Card from 'primevue/card';
import ProgressBar from 'primevue/progressbar';
import MenuHeader from '@/components/professor/MenuHeader.vue';
import { ordenarArrayDeObjetos } from '@/utils/ordenarArrayDeObjetos';
import AppAssinar from '../AppAssinar.vue';


const store = useStore();
const turmas = ref([]);
const turmasFiltradas = computed(() => {
    return turmas.value.filter(turma => turma.disciplinaId == disciplinaSelecionada.value)
})
const anosLetivos = ref([]);
const anoSelecionado = ref();
const disciplinaSelecionada = ref(null);
const opcoesDisciplinas = ref([]);


onMounted(() => {
    inicializar();
})


async function inicializar(){
    obterAnoAtual()

    if (store.state.turmasProfessor != null && store.state.disciplinasProfessor != null && store.state.anosLetivosProfessor != null) {
        turmas.value = store.state.turmasProfessor
        opcoesDisciplinas.value = store.state.disciplinasProfessor
        anosLetivos.value = store.state.anosLetivosProfessor
        disciplinaSelecionada.value = opcoesDisciplinas.value.find(item => item.disciplina !== 'Leitura')?.id
        await verificarAssinante()
        return
    }

    await Promise.all([
        verificarAssinante(),
        listarTurmas(),
        listarAnosLetivos()
    ])
}

const verificandoAssinatura = ref(true);
const assinaturaAtiva = ref();

async function verificarAssinante() {
    const userId = store.state.userSession.user.id;

    const { data, error } = await supabase
        .from('subscriptions')
        .select('*')
        .eq('user_id', userId)


    if (error) {
        console.error('Erro ao buscar assinaturas:', error);
        return;
    }

   

    verificandoAssinatura.value = false;
    assinaturaAtiva.value = data.some(assinatura => assinatura.status === 'active');

}

const loading = computed(() => store.state.loading);

const listarTurmas = async () => {
    store.dispatch('updateLoading',true)
    const userSession = store.state.userSession;
    const { data, error } = await supabase
        .from('cursos_professores')
        .select('id, professor, cursos!inner (anoDoEnsinoMedio, disciplinas(id,nome), anos_letivos(id,ano), aulas (id, turmas(nome,id)) )')
        .eq('professor', userSession.user.idU)
        .eq('cursos.anos_letivos.ano', anoSelecionado.value)
        .not('cursos.anos_letivos', 'is', null)

    if (data) {
        let turmasAulas = [];
        let disciplinas = []
        data.forEach(item => {
            let disciplina = item.cursos.disciplinas.nome;
            if(!disciplinas.find(d => d.id == item.cursos.disciplinas.id)){
                disciplinas.push({ id: item.cursos.disciplinas.id, disciplina: item.cursos.disciplinas.nome })
            }
            
            item.cursos.aulas.forEach(aula => {
                let turma = {
                    idDaAula: aula.id,
                    idDaTurma: aula.turmas.id,
                    nomeDaTurma: aula.turmas.nome,
                    anoDoEnsinoMedio: item.cursos.anoDoEnsinoMedio,
                    disciplina: disciplina,
                    disciplinaId: item.cursos.disciplinas.id
                };
                turmasAulas.push(turma);
            });
        });

        
 
        const ordenadas = ordenarArrayDeObjetos(turmasAulas, 'nomeDaTurma');
        turmas.value = ordenarArrayDeObjetos(ordenadas, 'anoDoEnsinoMedio')
        opcoesDisciplinas.value = disciplinas;
        disciplinaSelecionada.value = disciplinas.find(item => item.disciplina !== 'Leitura')?.id;

        store.dispatch('updateTurmasProfessor', turmas.value)
        store.dispatch('updateDisciplinasProfessor', disciplinas)
    }


    store.dispatch('updateLoading', false)

}

const verTurma = (turma) => {
    console.log(turma);
    store.dispatch('updateTurma',turma)
    router.push({path: '/professor/turma/notas'})
}


const listarAnosLetivos = async () => {
    const { data, error } = await supabase
        .from('anos_letivos')
        .select('ano')
    let anos = []
    data.forEach(item => anos.push(item.ano))
    anosLetivos.value = anos

    store.dispatch('updateAnosLetivosProfessor', anos)
}
function obterAnoAtual() {
    let dataAtual = new Date()
    anoSelecionado.value = dataAtual.getFullYear()
}

function definirImagem(ano){
    switch(ano){
        case "1": 
            return "https://www.gstatic.com/classroom/themes/SocialStudies.jpg"
        case "2":
            return "https://www.gstatic.com/classroom/themes/img_learnlanguage.jpg"
        case "3":
            return "https://www.gstatic.com/classroom/themes/Writing.jpg"
        default:
            return "https://www.gstatic.com/classroom/themes/Psychology.jpg"
    }
}
</script>
<style scoped>
.img{
    max-width: 100%;
}
.card {
    cursor: pointer;
}

</style>